require('jquery-ui-timepicker-addon');

const dataTablesConfig = require('./helpers/dataTablesConfig');
const generalEvents = require('./events/general-events');
const bootboxConfig = require('./helpers/bootboxConfig');
const onUrl = require('./helpers/onUrl');
const ChangeCostCenterReport = require('./functions/ChangeCostCenterReport'); // ver se esta usando
const AutoSelectAttributesFromReport = require('./functions/AutoSelectAttributesFromReport');
const TableLink = require('table-link');
const isMobile = require('is-mobile');
const isAndroid = require('is-android');
const FastClick = require('fastclick');
const InputMasks = require('./helpers/inputMasks');
const Approvals = require('./events/aprovar-reprovar');
const CalcCourseValue = require('./events/CalcCourseValue');
const HomeTutorial = require('./tutorials/HomeTutorial');
const makeDropdown = require('./functions/makeDropdown');
const OnchangeConfirmation = require('./events/OnchangeConfirmation');
const ValidateForms = require('./functions/ValidateForms');
const MultipleActionForm = require('./events/multipleActionForm');
const ModalWizard = require('./functions/ModalWizard');
const ModalOnboarding = require('./functions/ModalOnboarding');
const Pesquisa = require('./functions/Pesquisa');
const CitySelector = require('./functions/CitySelector');
const PaymentFormSelector = require('./functions/PaymentFormSelector');
const ClickDelay = require('./functions/ClickDelay');
const CurrencySelector = require('./functions/CurrencySelector');
const AprovadoresSelector = require('./functions/AprovadoresSelector');
const OnboardingSelectors = require('./functions/OnboardingSelectors');
const PanelMenuToggle = require('./functions/PanelMenuToggle');
const CreateOffice = require('./functions/CreateOffice');
const FilePicker = require('./functions/FilePicker');
const GlobalAlerts = require('./functions/GlobalAlerts');
const Pagamento = require('./functions/Pagamento');
const BuscaCep = require('./functions/BuscaCep');
const HistoryReport = require('./functions/history-report');
const ExpensesActions = require('./classes/ExpensesActions');
const ReportsActions = require('./classes/ReportsActions');
const ApprovalsActions = require('./classes/ApprovalsActions');
const FinanceiroEvents = require('./financeiro/FinanceiroEvents');
const FluxosAprovacaoEvents = require('./fluxos-aprovacao/FluxosAprovacaoEvents');
const IconCell = require('./functions/IconCell');
const AutoOpenModal = require('./functions/AutoOpenModal');
const validateFileImportExpense = require('./functions/validateFileImportExpense');
const ImportExpenses = require('./functions/ImportExpenses');
const LoadingForm = require('./functions/LoadingForm');
const PagarRelatorio = require('./functions/PagarRelatorio');
const ConciliarDespesas = require('./functions/ConciliarDespesas');
const AlterarDataPagamento = require('./functions/AlterarDataPagamento');
const AlterarConciliacao = require('./functions/AlterarConciliacao');
const ExportarIntegracao = require('./functions/ExportarIntegracao');
const DetalhesLoteIntegracao = require('./functions/DetalhesLoteIntegracao')
const FiltrarLotesEventosIntegracao = require('./functions/FiltrarLotesEventosIntegracao')
const confirm = require('./events/confirm');
const ModalClearFormOnClose = require('./functions/ModalClearFormOnClose');
const ModalChangePermissions = require('./functions/ModalChangePermissions');
const LimitesDeDespesa = require('./functions/LimitesDeDespesa');
const MultiModalCloseHandler = require('./functions/MultiModalCloseHandler');
const PanelActionButton = require('./functions/PanelActionButton');
const Clipboard = require('./functions/Clipboard');
const AlterarMoedaPadrao = require('./functions/AlterarMoedaPadrao');
const NiboEvents = require('./integrations/nibo/NiboEvents');
const ContaAzulEvents = require('./integrations/contaazul/ContaAzulEvents');
const PagnetEvents = require('./integrations/pagnet/PagnetEvents');
const FluigEvents = require('./integrations/fluig/FluigEvents');
const DatasulEvents = require('./integrations/datasul/DatasulEvents');
const MateraEvents = require('./integrations/matera/MateraEvents');
const OmieEvents = require('./integrations/omie/OmieEvents');
const FarmabaseEvents = require('./integrations/farmabase/FarmabaseEvents');
const MakeSwitcheryOnEach = require('./functions/MakeSwitcheryOnEach');
const ModalMembroAprovador = require('./functions/ModalMembroAprovador');
const SendResentLinkTeamMember = require('./functions/SendResentLinkTeamMember');
const ModalMembroEquipe = require('./functions/ModalMembroEquipe');
const ModalDespesaInconsistencias = require('./functions/ModalDespesaInconsistencias');
const FormValidateRecaptcha = require('./functions/FormValidateRecaptcha');
const MapaPercursoModalHandler = require('./functions/MapaPercursoModalHandler');
const MoedaEstrangeira = require('./functions/MoedaEstrangeira');
const LimitInputCharacters = require('./functions/LimitInputCharacters');
const JustOneRedirectLink = require('./events/JustOneRedirectLink');
const CheckboxEnableElement = require('./functions/CheckboxEnableElement');
const ClickOpenChat = require('./functions/ClickOpenChat');
const CleanFormSearchShowFilters = require('./functions/CleanFormSearchShowFilters');
const ConciliacoesDroppable = require('./functions/ConciliacoesDroppable');
const FecharItemsFatura = require('./functions/FecharItemsFatura');
const ConciliacoesFilters = require('./classes/ConciliacoesFilters');
const MakeInfiniteScrollOnEach = require('./functions/MakeInfiniteScrollOnEach');
const AlterarMoedaHistoricoSaque = require('./functions/AlterarMoedaHistoricoSaque');
const ReimportacaoLotes = require('./functions/ReimportacaoLotes');
const reprovarRelatorios = require('./events/reprovarRelatorios');
const SendContact = require('./functions/sendContact');
// const Mixpanel = require('./mixpanel/mixpanel');
const FiltroDespesasUsuario = require('./functions/FiltroDespesasUsuario');
const DespesasCartoes = require('./functions/DespesasCartoes');
const RedirectUserIntegration = require('./functions/RedirectUserIntegration');
const TipoVisualizacaoDados = require('./functions/TipoVisualizacaoDados');
const CheckboxDisableInput = require('./functions/CheckboxDisableInput');
const GeneralFormsExpense = require('./functions/GeneralFormsExpense');
const Onboarding = require('./functions/Onboarding');
const CambioDespesa = require('./functions/CambioDespesa');
const HorusAprovacoes = require('./functions/HorusAprovacoes');
const HorusRelatorioGerencial = require('./functions/HorusRelatorioGerencial');
const InternationalPhone = require('./functions/InternationalPhone');
const PoliticaKm = require('./classes/PoliticaKm');
const confirmIfExists = require('./functions/confirmIfExists');
const makeRequestSelectize = require('./functions/MakeRequestSelectize');
const ActiveDirectoryEvents = require('./integrations/active-directory/ActiveDirectoryEvents');
const Hydro = require('./integrations/hydro/HydroEvents');
const CustomFileInput = require('./functions/CustomFileInput');
const TagSettings = require('./app/settings/horus/tag/index');
const TagSettingsEdit = require('./app/settings/horus/tag/edit');
const RadioToggleElement = require('./functions/RadioToggleElement');
const LoginForm = require('./app/login/index');
const AnexoRelatorio = require('./functions/AnexoRelatorio');
const LazyLoad = require('./helpers/LazyLoad');
const StrongPassword = require('./functions/StrongPassword');
const handleCsrfToken = require('./helpers/handleCsrfToken');
const HandleShowPassword = require('./app/login/handleShowPassword');
const formExcelAdminEmpresas = require('./functions/formExcelAdminEmpresas');
const CambioLotes = require('./functions/CambioLotes')
const GenericaEvents = require('./integrations/generica/GenericaEvents');
const handleAjaxUnauthorized = require('./helpers/handleAjaxUnauthorized');
const AlternarMapaImagem = require('./functions/AlternarMapaImagem');
const handleClickToExpensesPageNewVersion = require('./app/expenses/handleClickToExpensesPageNewVersion');
const handleClickToReportsPageNewVersion = require('./app/reports/handleClickToReportsPageNewVersion');
const handleClickToApprovalsPageNewVersion = require('./app/approvals/handleClickToApprovalsPageNewVersion');
const handleClickToInitialPageMemberNewVersion = require('./app/membros-de-equipe/handleClickToInitialPageMemberNewVersion');
const handleClickToTabPageMemberNewVersion = require('./app/membros-de-equipe/handleClickToTabPageMemberNewVersion');
const handleClickToInitialPage = require('./app/inicio/handleClickToInitialPage');

const CardsPreviewJs = require('./cards/cards-preview-toggle-modal');
const NewButtonSwitchLanguage = require('./language-switcher/new-language-switcher-toggle-drop');
const SidebarDropdown = require('./dropdown/dropdown');
const GrabAndScroll = require('./grabAndScroll/grabAndSroll');
const Sidebar = require('./sidebar/sidebar');
// const ZendeskWebWidget = require('./integrations/zendesk/ZendeskWebWidget');
const AnexosObservacao = require('./anexo/anexoObservacao');
const GetBasfNotConfiguredEntities = require('./functions/GetBasfNotConfiguredEntities');
const InfinityScroll = require('./app/approvals/infinityScroll');
const GA4 = require('./ga4/ga4');
const Notifications = require('./notifications/notifications');
const SurveysEvents = require('./surveys/surveys');
const twoFactoryAuthentication = require('./app/login/twoFactoryAuthentication');
const uplift = require('./uplift/uplift');
const converterTributo = require('./converterTributo/converterTributo.js');

import ApprovalFlux from './classes/ApprovalFlux';
import DashboardTables from './classes/DashboardTables';
import Gmaps from './classes/Gmaps';
import Graphics from './classes/Graphics';
import SearchModalHandler from './functions/SearchModalHandler';
import expenseOnReport from './app/reports/expenseOnReport';
// import expenseOnApprovals from './app/approvals/expenseOnApprovals';
import imageViewerExtender from './imageViewerExtender/imageViewerExtender';

LazyLoad.init();

window.onload = function () {
  RedirectUserIntegration.init();

  bootbox.setDefaults(bootboxConfig.defaults);
  bootbox.addLocale('deletion', bootboxConfig.deletion);
  bootbox.addLocale('delete', bootboxConfig.delete);
  bootbox.addLocale('confirmation', bootboxConfig.confirmation);

  $.extend($.fn.dataTable.defaults, dataTablesConfig);

  TableLink.before(function (el, target) {
    return !(target.classList.contains('checkbox-cell'));
  });

  generalEvents();

  handleAjaxUnauthorized.init();
  InputMasks.init();
  CalcCourseValue.init();
  LoadingForm.init();
  FilePicker.init();
  TableLink.init();
  ValidateForms.init();
  MultipleActionForm.init();
  ModalWizard.init();
  ModalOnboarding.init();
  Pesquisa.init();
  CitySelector.init();
  PaymentFormSelector.init();
  BuscaCep.init();
  OnboardingSelectors.init();
  PanelMenuToggle.init();
  ChangeCostCenterReport.init();
  AutoSelectAttributesFromReport.init();
  GlobalAlerts.init();
  IconCell.init();
  AutoOpenModal.init();
  ModalClearFormOnClose.init();
  ModalChangePermissions.init();
  MultiModalCloseHandler.init();
  PanelActionButton.init();
  SearchModalHandler.init();
  Clipboard.init();
  CurrencySelector.init();
  AprovadoresSelector.init();
  ClickDelay.init();
  CheckboxEnableElement.init();
  ClickOpenChat.init();
  MakeSwitcheryOnEach.init();
  MakeInfiniteScrollOnEach.init();
  confirm.init();
  FormValidateRecaptcha.init();
  Gmaps.init();
  MapaPercursoModalHandler.init();
  LimitInputCharacters.init();
  JustOneRedirectLink.init();
  CleanFormSearchShowFilters.init();
  TipoVisualizacaoDados.init();
  CheckboxDisableInput.init();
  GeneralFormsExpense.init();
  CambioDespesa.init();
  InternationalPhone.init();
  makeRequestSelectize.init();
  CustomFileInput.init();
  RadioToggleElement.init();
  StrongPassword.init();
  handleCsrfToken.init();
  HandleShowPassword.init();
  CardsPreviewJs.init();
  NewButtonSwitchLanguage.init();
  SidebarDropdown.init();
  GrabAndScroll.init();
  Sidebar.init();
  AnexosObservacao.init();
  // ZendeskWebWidget.init();
  GetBasfNotConfiguredEntities.init();
  GA4.init();
  Notifications.init();
  SurveysEvents.init();
  uplift.init();

  // Eventos
  require('./events/signInSignUp');
  require('./events/signInMobile');
  require('./events/tab-link');
  require('./events/tipo-percurso');
  require('./events/flash');


  // Overlay Plugin
  require('./overlay');

  // Bind With Delay Plugin
  require('./bindWithDelay');

  require('../../translation/messages.js');

  const setFixedWidthFromElement = require('./functions/setFixedWidthFromElement');

  const $fixedTable = $('.table-container .data-tables').first();
  if ($fixedTable.length && !$fixedTable.hasClass('no-js') && !isMobile()) {
    const $fixedTableHeader = $fixedTable.find('thead > tr')
    const fixWidth = function () {
      $fixedTableHeader.find('th')
        .each(function (n, el) {
          if (!el.classList.contains('checkbox-cell')) {
            setFixedWidthFromElement(el, false);
            $fixedTable.find('tbody td:nth-child(' + (n + 1) + '):not(.checkbox-cell)')
              .width(parseInt($(el).width()));
          }
        });
    };
    fixWidth();
    nifty.window.resize(function () {
      fixWidth();
    });
    nifty.body.on('DOMNodeInserted', '.data-tables', function () {
      fixWidth();
    });
  }

  onUrl(LoginForm.url, function () {
    LoginForm.init();
  });

  onUrl(ExpensesActions.URL, function () {
    new ExpensesActions();
  });

  onUrl(ReportsActions.URL, function () {
    new ReportsActions();
  });

  onUrl(ApprovalsActions.URL, function () {
    new ApprovalsActions();
  });

  onUrl(/^\/conciliacoes$/, function () {
    new ConciliacoesFilters();
  });

  onUrl(/^\/admin\/conciliacoes\/encerrar-fatura$/, function () {
    new ConciliacoesFilters();
  });

  onUrl(HomeTutorial.url, function () {
    makeDropdown('#dropdown-user');
  });

  onUrl(imageViewerExtender.url, imageViewerExtender.init);

  onUrl(converterTributo.url, converterTributo.init);

  onUrl(CreateOffice.url, CreateOffice.init);

  onUrl(FluxosAprovacaoEvents.url, FluxosAprovacaoEvents.init);

  onUrl(FinanceiroEvents.url, FinanceiroEvents.init);

  // onUrl(Mixpanel.url, function () {
  //   Mixpanel.init();
  // });

  onUrl(/^\/admin\/reprovar-relatorios|aprovacoes/, function () {
    reprovarRelatorios.init();
  });

  onUrl(/^\/periodo-teste-finalizado/, function () {
    SendContact.init();
  })
  HistoryReport.init();

  onUrl(confirmIfExists.url, confirmIfExists.init);

  onUrl(Pagamento.url, Pagamento.init);

  onUrl(AlternarMapaImagem.url, AlternarMapaImagem.init);
  onUrl(AlterarDataPagamento.url, AlterarDataPagamento.init);
  onUrl(AlterarConciliacao.url, AlterarConciliacao.init);
  onUrl(ExportarIntegracao.url, ExportarIntegracao.init);
  onUrl(DetalhesLoteIntegracao.url, DetalhesLoteIntegracao.init);
  onUrl(FiltrarLotesEventosIntegracao.url, FiltrarLotesEventosIntegracao.init);
  onUrl(ReimportacaoLotes.url, ReimportacaoLotes.init);
  onUrl(FiltroDespesasUsuario.url, FiltroDespesasUsuario.init);
  onUrl(DespesasCartoes.url, DespesasCartoes.init);
  onUrl(CambioLotes.url, CambioLotes.init);
  onUrl(handleClickToExpensesPageNewVersion.url, handleClickToExpensesPageNewVersion.init);
  onUrl(handleClickToReportsPageNewVersion.url, handleClickToReportsPageNewVersion.init);
  onUrl(handleClickToInitialPageMemberNewVersion.url, handleClickToInitialPageMemberNewVersion.init);
  onUrl(handleClickToTabPageMemberNewVersion.url, handleClickToTabPageMemberNewVersion.init);
  onUrl(handleClickToInitialPage.url, handleClickToInitialPage.init);
  onUrl(handleClickToApprovalsPageNewVersion.url, handleClickToApprovalsPageNewVersion.init);

  validateFileImportExpense.init();
  ImportExpenses.init();

  onUrl(/\/(limites-de-despesa|tipos)\/[0-9]+/gi, LimitesDeDespesa.init)

  onUrl(AlterarMoedaPadrao.url, AlterarMoedaPadrao.init);

  onUrl(OnchangeConfirmation.url, OnchangeConfirmation.init);

  if (document.getElementsByClassName('js-approvals-trigger').length) {
    const approvals = new Approvals();
  }


  onUrl('/admin/pagamentos', PagarRelatorio.init);
  onUrl(ConciliarDespesas.url, ConciliarDespesas.init);

  onUrl(ApprovalFlux.url, ApprovalFlux.init);

  onUrl(Graphics.url, () => {
    Graphics.init('#form-filter', '.graphic');
  });
  onUrl(DashboardTables.url, DashboardTables.init);
  onUrl(NiboEvents.url, NiboEvents.init);
  onUrl(ContaAzulEvents.url, ContaAzulEvents.init);
  onUrl(PagnetEvents.url, PagnetEvents.init);
  onUrl(DatasulEvents.url, DatasulEvents.init);
  onUrl(FluigEvents.url, FluigEvents.init);
  onUrl(MateraEvents.url, MateraEvents.init);
  onUrl(OmieEvents.url, OmieEvents.init);
  onUrl(FarmabaseEvents.url, FarmabaseEvents.init);
  onUrl(ActiveDirectoryEvents.url, ActiveDirectoryEvents.init);
  onUrl(Hydro.url, Hydro.init);
  onUrl(GenericaEvents.url, GenericaEvents.init);

  onUrl(ModalMembroAprovador.url, ModalMembroAprovador.init);
  onUrl(SendResentLinkTeamMember.url, SendResentLinkTeamMember.init);
  onUrl(ModalMembroEquipe.url, ModalMembroEquipe.init);
  onUrl(ModalDespesaInconsistencias.url, ModalDespesaInconsistencias.init);
  onUrl(MoedaEstrangeira.url, MoedaEstrangeira.init);
  onUrl(ConciliacoesDroppable.url, ConciliacoesDroppable.init);
  onUrl(FecharItemsFatura.url, FecharItemsFatura.init);
  onUrl(AlterarMoedaHistoricoSaque.url, AlterarMoedaHistoricoSaque.init);
  onUrl(formExcelAdminEmpresas.url, formExcelAdminEmpresas.init);

  onUrl(Onboarding.url, Onboarding.init);
  onUrl(PoliticaKm.url, PoliticaKm.init);
  onUrl(HorusAprovacoes.url, HorusAprovacoes.init);
  onUrl(HorusRelatorioGerencial.url, HorusRelatorioGerencial.init);

  onUrl(TagSettings.url, TagSettings.init);
  onUrl(TagSettingsEdit.url, TagSettingsEdit.init);

  onUrl(AnexoRelatorio.url, AnexoRelatorio.init);

  onUrl(InfinityScroll.url, InfinityScroll.init);
  onUrl(expenseOnReport.url, expenseOnReport.init);
  // onUrl(expenseOnApprovals.url, expenseOnApprovals.init);

  onUrl(/^\/two-factor|two-factor-mobile/, function () {
    twoFactoryAuthentication.init();
  });

  const modals = $('.modal');
  const modalDialogs = $('.modal-dialog');
  nifty.body.overlay({ fixed: true });

  FastClick(document.body);

  if (isMobile() || isAndroid) {
    nifty.document.on('click', 'a:not([data-gallery],.dropdown-toggle,[class^="ui-"], .js-ignore-mobile-loading)',
      function (e) {
        nifty.body.overlay('show');
        setTimeout(function () {
          nifty.body.overlay('hide');
        }, 5e3);

      });

    modals.removeClass('fade');
    modalDialogs.addClass('animated fadeInLeft');
  }

  const contako = $('#divContakoWidgetJSFixo');
  const scrollTop = $('#scroll-top');
  if (!isMobile()) {
    contako.addClass('contako-widget');
    nifty.window.on('scroll', function () {
      const actions = document.querySelector('.actions');
      const dragClass = contako.length ? 'actions--drag' : 'actions--double-drag';
      if (scrollTop.hasClass('in')) {
        actions && actions.classList.add(dragClass);
        contako.addClass('contako-widget--drag');
      } else {
        actions && actions.classList.remove(dragClass);
        contako.removeClass('contako-widget--drag');
      }
    });
  } else {
    contako.remove();
  }

  $('form:not(.js-ignore-request-duplication)')
    .on('submit', function (e) {
      const target = $(e.currentTarget);
      target.off('submit');
      target.on('submit', function () {
        return false;
      });
    });

  // Função que minimiza os menus principais
  $('.panel__menu-item--dropdown > a').on('click', function () {
    $(this.parentNode).toggleClass('is-open');
  });

  $('.panel__menu-item--dropdown:not(:has(li))').addClass('hidden');
};

// $('#dataInicial').datepicker({
//   onSelect: function(date) {
//     console.log('date: ', date);
//     console.log('$(this): ', $(this));
//     return $(this).change();
//   }
// });
